export default {
    API_ENDPOINT: 'https://myusedcarsalesman-api-auth.azurewebsites.net/api',
    //API_ENDPOINT: 'http://localhost:8000/api',
    TOKEN_KEY: 'myusedcarsalesman-client-auth-token',
    ADMIN_TOKEN_KEY: 'myusedcarsalesman-client-admin-auth-token',
}
  